import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-team-members',
  templateUrl: './team-members.component.html',
  styleUrls: ['./team-members.component.scss']
})
export class TeamMembersComponent {
  @Input() member: any = {};
  team = [];
  shown_team = [];
  config: SwiperOptions = {
    pagination: { 
      el: '.swiper-pagination', 
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 15,
    slidesPerView: 4,
    speed: 500,
    loop: true,
    breakpoints: {
      640: {
          slidesPerView: 2,
          spaceBetween: 15,
      },
      768: {
          slidesPerView: 3,
          spaceBetween: 15,
      },
      1024: {
          slidesPerView: 4,
          spaceBetween: 15,
      },
    }, a11y: {
      containerMessage: 'Out team members',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    },
  };  
  constructor(private router: Router) {
    this.team = [{
      name: 'Kunal Chauhan',
      designation: 'Product Designer',
      img: 'assets/img/people/nitin_gupta.jpg'
    }];

    for(let i = 0; i < 6; i++){
      this.shown_team.push(this.team[0]);
    }

    this.member = {
      id: 0,
      name: 'You could be next!',
      designation: '',
      img: 'assets/img/question_mark.svg'
    }
  }

  ngOnChanges(changes){
    if(changes && changes.member && changes.member.currentValue){
      this.member = changes.member.currentValue;
    } else {
      this.member = {
        id: 0,
        name: 'You could be next!',
        designation: '',
        img: 'assets/img/question_mark.svg'
      }
    }
  }

  ngOnInit(){
  }
  clickJoin(card){
    if(card.id == 0){
      this.router.navigate([]).then(result => {  window.open('/careers', '_blank'); });

    }
  }
}
